import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';

const AccountNoticeModal = ({ modalShow, setModalShow }) => {
  return (
    <Modal size="lg" show={modalShow} onHide={() => setModalShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          Ehi ragazzi, abbiamo fatto un po' di pulizia! 🧹
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">Ciao a tutti!</p>
        <p className="mb-3">
          Abbiamo fatto un{' '}
          <strong>bel reset di tutti gli account creati prima del 2024</strong>.
          Sì, avete capito bene!
        </p>
        <ul className="list-disc list-inside mb-3">
          <li>
            Tutti gli account "vintage" (pre-2024) sono stati{' '}
            <strong>rimossi</strong> 👋
          </li>
          <li>
            Le classi?
            <br />
            Puff, <strong>sparite</strong>! 📚
          </li>
          <li>
            Studenti e prof di quelle classi?
            <br />
            In <strong>vacanza permanente</strong> 🏖️
          </li>
          <li>
            Bonus e malus? <br />
            <strong>Azzerati</strong> come per magia ✨
          </li>
        </ul>
        <p className="mb-3">
          Sappiamo che è un po' un casino, ma era{' '}
          <strong>necessario per motivi tecnici</strong> (roba da nerd, fidatevi
          🤓).
        </p>
        <p className="mb-3">
          Se volete continuare a usare il sito,{' '}
          <strong>dovrete creare un nuovo account</strong>. Pensatela come una
          chance per ricominciare da zero!
        </p>
        <p className="mb-0">
          Domande? Perplessità? Voglia di sfogarvi? Il nostro{' '}
          <strong>team di supporto è qui per voi</strong>. Non siate timidi,{' '}
          <a href="mailto:info@fantaclasse.it">
            <strong>contattateci</strong>
          </a>
          !
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setModalShow(false)}>Capito 🫡</Button>
      </Modal.Footer>
    </Modal>
  );
};

AccountNoticeModal.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired
};

const AccountNotice = () => {
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      <AccountNoticeModal modalShow={modalShow} setModalShow={setModalShow} />
      <p className="fs-10 mt-2 mb-0 text-center">
        Hai creato il tuo account prima del 2024?{' '}
        <a href="#" onClick={() => setModalShow(true)}>
          Clicca qui
        </a>
        .
      </p>
    </>
  );
};

export default AccountNotice;
